import React, { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import ChevronRight from 'icons/src/ChevronRight';

const FooterCol = ({ children, title }) => {
  const [isOpen, setOpen] = useState(false);
  const onClick = useCallback(() => setOpen((state) => !state), []);
  return (
    <div>
      <Title title={title} onClick={onClick}>
        <span>{title}</span>
        <Icon isOpen={isOpen} as={ChevronRight} />
      </Title>
      <ColContent open={isOpen}>
        <ColPadding>
          {children}
        </ColPadding>
      </ColContent>
    </div>
  );
};

const ColContent = styled.div`
  @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
    height: 0;
    overflow: hidden;
    border-bottom: 1px solid ${({ theme }) => theme.grayDarkColor};
    ${({ open }) => open && css`
      height: auto;
      overflow: auto;
    `}
  }
`;

const ColPadding = styled.div`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding-top: 1rem;
  }
  @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding-bottom: 1rem;
  }
  display: grid;
  grid-template-rows: auto;
  gap: 1rem;
`;

const Icon = styled.span`
  transition: .2s;
  color: ${({ theme }) => theme.primaryColor};
  ${({ isOpen }) => isOpen && css`
    transform: rotate(90deg);
  `}
`;

const Title = styled(Button).attrs(({ $isOpen, title }) => ({
  wrapper: true,
  nav: true,
  navType: 'nav_tab',
  menuName: title,
  eventAction: $isOpen ? 'decrease' : 'increase',
}))`
  display: block;
  width: 100%;
  text-align: left;
  color: white;
  font-size: 1.375rem;
  font-weight: 700;
  cursor: none;
  pointer-events: none;

  ${Icon} {
    display: none;
  }

  @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: flex;
    padding: 20px 0;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    pointer-events: auto;

    ${Icon} {
      display: inline-block;
      width: .5em;
      height: auto;
    }
  }
`;

export default FooterCol;
